<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="row" style="text-align: center">
    <div class="col-md-12">
      <br />
      <div>
        <button @click="redirect()" class="btn btn-primary btn-lg" style="font-size: 17px">Voltar</button>
      </div>
      <br />
    </div>
  </div>

  <!-- DADOS PF -->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Dados da empresa</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- CNPJ -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="exampleInputEmail1">CNPJ</label>

                <InputMask id="basic" class="form-control" v-model="formData.cnpj" mask="99.999.999/9999-99" />

                <span style="color: red" v-for="error in v$.cnpj.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- RAZÃO SOCIAL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="razao_social">Razão social</label>
                <input style="text-transform: uppercase" class="form-control" id="razao_social" v-model="formData.razao_social" />

                <span style="color: red" v-for="error in v$.razao_social.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NOME FANTASIA -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="nome_fantasia">Nome fantasia</label>
                <input style="text-transform: uppercase" class="form-control" id="nome_fantasia" v-model="formData.nome_fantasia" />

                <span style="color: red" v-for="error in v$.nome_fantasia.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CEP -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_cep">CEP</label>

                <div class="input-group">
                  <InputMask id="basic" class="form-control" v-model="formData.pj_endereco_cep" placeholder="_______-___" mask="99999-999" />

                  <span class="input-group-append">
                    <button @click="buscarCepPJ()" type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button>
                  </span>
                </div>

                <span style="color: red" v-for="error in v$.pj_endereco_cep.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO LOGRADOURO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="pj_endereco">Logradouro</label>
                <input style="text-transform: uppercase" class="form-control" id="pj_endereco" v-model="formData.pj_endereco" />

                <span style="color: red" v-for="error in v$.pj_endereco.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO NÚMERO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_num">Número</label>
                <input style="text-transform: uppercase" class="form-control" id="pj_endereco_num" v-model="formData.pj_endereco_num" />

                <span style="color: red" v-for="error in v$.pj_endereco_num.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO COMPLEMENTO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_complemento">Complemento</label>
                <input
                  style="text-transform: uppercase"
                  class="form-control"
                  id="pj_endereco_complemento"
                  v-model="formData.pj_endereco_complemento"
                />
              </div>
            </div>

            <!-- ENDERECO BAIRRO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_bairro">Bairro</label>
                <input style="text-transform: uppercase" class="form-control" id="pj_endereco_bairro" v-model="formData.pj_endereco_bairro" />

                <span style="color: red" v-for="error in v$.pj_endereco_bairro.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_cidade">Cidade</label>
                <input style="text-transform: uppercase" class="form-control" id="pj_endereco_cidade" v-model="formData.pj_endereco_cidade" />

                <span style="color: red" v-for="error in v$.pj_endereco_cidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="pj_endereco_estado">Estado</label>
                <input style="text-transform: uppercase" class="form-control" id="pj_endereco_estado" v-model="formData.pj_endereco_estado" />

                <span style="color: red" v-for="error in v$.pj_endereco_estado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- REQUER AUTORIZAÇÃO SUCATA 
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="requer_autorizacao_sucata">Requer autorização sucata</label>

                                <select class="custom-select rounded-0" id="requer_autorizacao_sucata"
                                    v-model="formData.requer_autorizacao_sucata">
                                    <option :value="0">NÃO</option>
                                    <option :value="1">SIM</option>
                                </select>

                                <span style="color: red" v-for="error in v$.requer_autorizacao_sucata.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </span>
                            </div>
                        </div>
                        -->
          </div>
        </div>

        <div class="card-header">
          <h3 class="card-title" style="color: white">Dados do representante legal</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- NOME COMPLETO -->
            <div class="col-sm-9">
              <div class="form-group">
                <label for="exampleInputEmail1">Nome completo</label>
                <input style="text-transform: uppercase" class="form-control" id="nome_completo" v-model="formData.nome_completo" />

                <span style="color: red" v-for="error in v$.nome_completo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- CPF -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="cpf">CPF</label>

                <InputMask id="basic" class="form-control" v-model="formData.cpf" placeholder="___.___.___-__" mask="999.999.999-99" />

                <span style="color: red" v-for="error in v$.cpf.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="cpf">RG</label>
                <input class="form-control" id="cpf" v-model="formData.rg" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ORGÃO EXPEDIDOR -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="orgao_expedidor">Orgão expedidor</label>

                <input class="form-control" id="orgao_expedidor" v-model="formData.orgao_expedidor" style="text-transform: uppercase" />

                <span style="color: red" v-for="error in v$.rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>

                <span style="color: red" v-for="error in v$.orgao_expedidor.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA EMISSÃO RG -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="data_emissao_rg">Data emissão RG</label>

                <InputMask id="basic" class="form-control" v-model="formData.data_emissao_rg" placeholder="__/__/____" mask="99/99/9999" />

                <span style="color: red" v-for="error in v$.data_emissao_rg.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DATA NASCIMENTO-->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="data_emissao_rg">Data de nascimento</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.data_nascimento"
                  placeholder="__/__/____"
                  mask="99/99/9999"
                  slotChar="__/__/____"
                />

                <span style="color: red" v-for="error in v$.data_nascimento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NACIONALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="nacionalidade">Nacionalidade</label>

                <input style="text-transform: uppercase" class="form-control" id="nacionalidade" v-model="formData.nacionalidade" />

                <span style="color: red" v-for="error in v$.nacionalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NATURALIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="naturalidade">Naturalidade (Cidade/Estado)</label>

                <input style="text-transform: uppercase" type="text" class="form-control" id="naturalidade" v-model="formData.naturalidade" />

                <span style="color: red" v-for="error in v$.naturalidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FILIAÇÃO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="conjuge_profissao">Filiação (Nome COMPLETO da mãe e Nome COMPLETO do pai)</label>
                <input style="text-transform: uppercase" class="form-control" id="filiacao" v-model="formData.filiacao" />

                <span style="color: red" v-for="error in v$.filiacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- SEXO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="sexo">Sexo</label>

                <select class="custom-select rounded-0" id="sexo" v-model="formData.sexo">
                  <option value="Feminino">FEMININO</option>
                  <option value="Masculino">MASCULINO</option>
                </select>

                <span style="color: red" v-for="error in v$.sexo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ESTADO CIVIL -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="estado_civil">Estado civil</label>

                <select class="custom-select rounded-0" id="estado_civil" v-model="formData.estado_civil" style="text-transform: uppercase">
                  <option value="casado">Casado</option>

                  <option value="divorciado">Divorciado</option>
                  <option value="separado_judicialmente">Separado judicialmente</option>
                  <option value="solteiro_com_uniao_estavel">Solteiro com união estável</option>
                  <option value="solteiro_sem_uniao_estavel">Solteiro sem união estável</option>
                  <option value="viuvo">Viúvo</option>
                </select>

                <span style="color: red" v-for="error in v$.estado_civil.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- REGIME CASAMENTO -->
            <div
              class="col-sm-12"
              v-if="
                formData.estado_civil == 'casado' || formData.estado_civil == 'uniao_estavel' || formData.estado_civil == 'solteiro_com_uniao_estavel'
              "
            >
              <div class="form-group">
                <label for="regime_casamento">Regime do casamento</label>
                <select class="custom-select rounded-0" id="regime_casamento" v-model="formData.regime_casamento" style="text-transform: uppercase">
                  <option value="cpb">Comunhão parcial de bens</option>
                  <option value="cub">Comunhão universal de bens</option>
                  <option value="outros">Outros</option>
                  <option value="pfa">Participação final nos aquestos</option>
                  <option value="seb">Separação de bens</option>
                </select>

                <span style="color: red" v-for="error in v$.regime_casamento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CEP -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cep">CEP</label>

                <div class="input-group">
                  <InputMask id="basic" class="form-control" v-model="formData.endereco_cep" placeholder="_______-___" mask="99999-999" />

                  <span class="input-group-append">
                    <button @click="buscarCep()" type="button" class="btn btn-info btn-flat"><i class="fa fa-search"></i></button>
                  </span>
                </div>

                <span style="color: red" v-for="error in v$.endereco_cep.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO LOGRADOURO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco">Logradouro</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco" v-model="formData.endereco" />

                <span style="color: red" v-for="error in v$.endereco.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO NÚMERO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_num">Número</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_num" v-model="formData.endereco_num" />

                <span style="color: red" v-for="error in v$.endereco_num.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO COMPLEMENTO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_complemento">Complemento</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_complemento" v-model="formData.endereco_complemento" />
              </div>
            </div>

            <!-- ENDERECO BAIRRO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_bairro">Bairro</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_bairro" v-model="formData.endereco_bairro" />

                <span style="color: red" v-for="error in v$.endereco_bairro.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_cidade" v-model="formData.endereco_cidade" />

                <span style="color: red" v-for="error in v$.endereco_cidade.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">Estado</label>
                <input style="text-transform: uppercase" class="form-control" id="endereco_estado" v-model="formData.endereco_estado" />

                <span style="color: red" v-for="error in v$.endereco_estado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FONE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="fone">Telefone fixo</label>

                <!-- <InputMask placeholder="(__)_____-____" id="basic" class="form-control" v-model="formData.fone" mask="(99)99999-9999" /> -->

                <input class="form-control" v-model="formData.fone" />

                <span v-if="formData.fone" style="color: red" v-for="error in v$.fone.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- CELULAR -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="Celular">
                  Celular (com DDD)
                  <span style="color: red; margin-left: 5px">*Será enviado um SMS para validar</span>
                </label>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <img width="60px" height="37px" src="https://rochaleiloes.com.br/dist/img/Brazil_flag_300.png" />
                  </div>
                  <InputMask id="basic" class="form-control" v-model="formData.celular" placeholder="(__)_____-____" mask="(99)99999-9999" />
                </div>

                <span style="color: red" v-for="error in errors.telefone_celular" :key="error">
                  {{ error }}
                </span>

                <span style="color: red" v-for="error in v$.celular.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- PROFISSAO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="profissao">Profissão</label>
                <input style="text-transform: uppercase" class="form-control" id="profissao" v-model="formData.profissao" />

                <span style="color: red" v-for="error in v$.profissao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="enviar()">Cadastrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loading from "vue-loading-overlay";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { email, sameAs, helpers } from "@vuelidate/validators";
import { required, minLength, maxLength } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["orgaos_expedidores_rg", "paises"],

  components: { Loading, InputMask },

  setup() {
    const formData = reactive({
      fone: "",
      celular: "",
      profissao: "",
      filiacao: "",
      cadastro_tipo: "pf",
      nome_completo: "",
      cadastro_tipo: "pj",
      razao_social: "",
      nome_fantasia: "",
      cnpj: "",
      cpf: "",
      rg: "",
      orgao_expedidor: "",
      data_emissao_rg: "",
      naturalidade: "",
      nacionalidade: "",
      data_nascimento: "",
      sexo: "",
      regime_casamento: "",
      estado_civil: "",
      requer_autorizacao_sucata: 0,
      endereco_cep: "",
      endereco_num: "",
      endereco_complemento: "",
      endereco_bairro: "",
      endereco: "",
      endereco_estado: "",
      endereco_estado_id: "",
      endereco_cidade: "",
      endereco_cidade_id: "",
      endereco_complemento: "",
      pj_endereco_cep: "",
      pj_endereco_num: "",
      pj_endereco_complemento: "",
      pj_endereco_bairro: "",
      pj_endereco: "",
      pj_endereco_estado: "",
      pj_endereco_estado_id: "",
      pj_endereco_cidade: "",
      pj_endereco_cidade_id: "",
      pj_endereco_complemento: "",
    });

    const rules = computed(() => {
      let local_rules = {
        fone: { maxLength: maxLength(20) },
        filiacao: { required },
        celular: { required, minLength: minLength(11) },
        cadastro_tipo: { required },
        razao_social: { required },
        nome_fantasia: { required },
        profissao: { required },
        cnpj: { required, validarCPF: helpers.withMessage(" Digite um CNPJ válido.", validarCNPJ) },
        endereco_cep: { required },
        endereco_cidade: { required },
        endereco_estado: { required },
        endereco: { required },
        endereco_bairro: { required },
        endereco_num: { required },
        nome_completo: { required },
        orgao_expedidor: { required },
        cpf: { required, validarCPF: helpers.withMessage(" Digite um CPF válido.", validarCPF) },
        rg: { required },
        data_emissao_rg: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        naturalidade: { required },
        nacionalidade: { required },
        data_nascimento: {
          required,
          validDate: helpers.withMessage(" Digite uma data válida.", validDate),
          minDate: helpers.withMessage(" A data não pode ser maior que hoje.", minDate),
        },
        sexo: { required },
        estado_civil: { required },
        pj_endereco_cep: { required },
        pj_endereco_cidade: { required },
        pj_endereco_cidade_id: "",
        pj_endereco_estado: { required },
        pj_endereco_estado_id: "",
        pj_endereco: { required },
        pj_endereco_bairro: { required },
        pj_endereco_num: { required },
      };

      if (formData.estado_civil == "casado" || formData.estado_civil == "uniao_estavel" || formData.estado_civil == "solteiro_com_uniao_estavel") {
        local_rules.regime_casamento = {
          required,
        };
      }

      return local_rules;
    });

    const validDate = (value) => {
      return moment(value, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date";
    };

    //DATA MENOR QUE HOJE
    const minDate = (date) => {
      if (moment(date, "DD/MM/yyyy").format("yyyy-MM-DD") != "Invalid date") {
        let data = new Date(moment(date, "DD/MM/yyyy"));

        return data < new Date();
      } else {
        return true;
      }
    };

    const minBirthDate = (date) => {
      return new Date(date) >= new Date("01-01-1940");
    };

    const validarCPF = (cpf) => {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    };

    const validarCNPJ = (cnpj) => {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var c = String(cnpj).replace(/[^\d]/g, "");

      if (c.length !== 14) return false;

      if (/0{14}/.test(c)) return false;

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      return true;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      isLoading: false,
      termos: false,
      cep_valido: false,
      campos_endereco_bloqueados: true,
      errors: [],
    };
  },

  mounted() {
    console.log(this.orgaos_emissores);
  },

  methods: {
    validateCelular() {
      if (this.formData.celular) {
        let data = {
          telefone_celular: this.formData.celular.replace(/[^Z0-9]/g, ""),
        };

        console.log("Enviando");
        console.log(data);

        axios
          .post("/user/cadastro/validate_celular", data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              this.errors.telefone_celular = [];
            } else {
              this.errors.telefone_celular = ["Celular inválido ou já cadastrado!"];
            }
          })
          .catch((error) => {
            console.log(error);

            return false;
          });
      }
    },

    redirect() {
      window.location.href = "/user";
    },

    buscarCep() {
      this.isLoading = true;
      this.cep_valido = false;

      let cep = this.formData.endereco_cep.replace(/[^Z0-9]/g, "");

      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          this.isLoading = false;

          console.log(response.data);

          let dados = response.data;

          console.log(dados);

          this.buscarCidade(dados);

          this.formData.endereco = dados.logradouro;
          this.formData.endereco_bairro = dados.bairro;
          this.formData.endereco_cidade = dados.localidade;

          this.cep_valido = true;
        })
        .catch((error) => {
          console.log(error);

          if (error.response && error.response.status == 400) {
            this.showErrorMessageWithButton("Ops...", "Digite um cep válido!");
            this.cep_valido = false;
            this.isLoading = false;
          } else {
            this.showErrorMessageWithButton("Ops...", "Cep inválido.");
            this.cep_valido = false;
            this.isLoading = false;
          }
        });
    },

    buscarCepPJ() {
      this.isLoading = true;
      this.cep_valido = false;

      let cep = this.formData.pj_endereco_cep.replace(/[^Z0-9]/g, "");

      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          this.isLoading = false;

          console.log(response.data);

          let dados = response.data;

          console.log(dados);

          this.buscarCidadePJ(dados);

          this.formData.pj_endereco = dados.logradouro;
          this.formData.pj_endereco_bairro = dados.bairro;
          this.formData.pj_endereco_cidade = dados.localidade;

          this.cep_valido = true;
        })
        .catch((error) => {
          this.isLoading = false;

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarCidadePJ(dados) {
      console.log("Buscando cidade");

      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            this.formData.pj_endereco_cidade = response.data.cidade.nome;
            this.formData.pj_endereco_cidade_id = response.data.cidade.id;

            this.formData.pj_endereco_estado = response.data.estado.nome;
            this.formData.pj_endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.pj_cidade = response.data.cidade = "";
            this.formData.pj_estado = response.data.estado = "";

            this.formData.pj_endereco_estado = "";
            this.formData.pj_endereco_estado_id = "";
          }

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidade(dados) {
      console.log("Buscando cidade");

      let data = {
        nome: dados.localidade,
        estado_sigla: dados.uf,
      };

      console.log(data);

      axios
        .post(`/user/cidade/buscar`, data)
        .then((response) => {
          if (response.data.success) {
            this.formData.endereco_cidade = response.data.cidade.nome;
            this.formData.endereco_cidade_id = response.data.cidade.id;

            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.cidade = response.data.cidade = "";
            this.formData.estado = response.data.estado = "";

            this.formData.endereco_estado = "";
            this.formData.endereco_estado_id = "";
          }

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarCidadePorNome(callback) {
      if (this.formData.endereco_estado_id != null && this.formData.endereco_cidade) {
        let data = {
          nome: this.formData.endereco_cidade,
          estado_id: this.formData.endereco_estado_id,
        };

        console.log(data);

        axios
          .post(`/user/endereco/cidade_por_nome`, data)
          .then((response) => {
            if (response.data.cidade) {
              this.formData.endereco_cidade = response.data.cidade.nome;
              this.formData.endereco_cidade_id = response.data.cidade.id;
            } else {
              this.formData.endereco_cidade_id = null;
            }

            callback();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.formData.endereco_cidade_id = null;
        callback();
      }
    },

    buscarCidadePJPorNome(callback) {
      if (this.formData.pj_endereco_estado_id != null && this.formData.pj_endereco_cidade) {
        let data = {
          nome: this.formData.pj_endereco_cidade,
          estado_id: this.formData.pj_endereco_estado_id,
        };

        console.log(data);

        axios
          .post(`/user/endereco/cidade_por_nome`, data)
          .then((response) => {
            if (response.data.cidade) {
              this.formData.pj_endereco_cidade = response.data.cidade.nome;
              this.formData.pj_endereco_cidade_id = response.data.cidade.id;
            } else {
              this.formData.pj_endereco_cidade_id = null;
            }

            callback();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.formData.pj_endereco_cidade_id = null;
        callback();
      }
    },

    buscarEstadoPorNome(callback) {
      let data = {
        nome: this.formData.endereco_estado.toUpperCase(),
      };

      console.log(data);

      axios
        .post(`/user/endereco/estado_por_nome`, data)
        .then((response) => {
          console.log("Resposta estado");
          console.log(response.data);

          if (response.data.estado) {
            this.formData.endereco_estado = response.data.estado.nome;
            this.formData.endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.endereco_estado_id = null;
          }

          callback();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarEstadoPJPorNome(callback) {
      let data = {
        nome: this.formData.pj_endereco_estado.toUpperCase(),
      };

      console.log(data);

      axios
        .post(`/user/endereco/estado_por_nome`, data)
        .then((response) => {
          console.log("Resposta estado");
          console.log(response.data);

          if (response.data.estado) {
            this.formData.pj_endereco_estado = response.data.estado.nome;
            this.formData.pj_endereco_estado_id = response.data.estado.id;
          } else {
            this.formData.pj_endereco_estado_id = null;
          }

          callback();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    async enviar() {
      const result = await this.v$.$validate();

      //CALCULAR TOTAL ERROS
      let keys = Object.keys(this.errors);
      let total = 0;

      for (let i = 0; i < keys.length; i++) {
        if (this.errors[keys[i]] && this.errors[keys[i]].length && this.errors[keys[i]].length != 0) {
          total++;
        }
      }

      this.errors.total = total;

      if (result && this.errors.total == 0) {
        this.buscarEstadoPJPorNome(() => {
          this.buscarCidadePJPorNome(() => {
            this.buscarEstadoPorNome(() => {
              this.buscarCidadePorNome(() => {
                if (this.formData.pj_endereco_estado_id == null) {
                  this.showErrorMessageWithButton("Ops...", "Confira o nome do estado da empresa");
                } else if (this.formData.pj_endereco_cidade_id == null) {
                  this.showErrorMessageWithButton("Ops...", "Confira o nome da cidade da empresa");
                } else if (this.formData.endereco_estado_id == null) {
                  this.showErrorMessageWithButton("Ops...", "Confira o nome do estado do responsável legal");
                } else if (this.formData.endereco_cidade_id == null) {
                  this.showErrorMessageWithButton("Ops...", "Confira o nome da cidade do responsável legal");
                } else if (result) {
                  this.create();
                }
              });
            });
          });
        });
      }
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD");
    },

    async create() {
      this.isLoading = true;

      let data = {
        nome: this.formData.nome_completo.toUpperCase(),
        cpf: this.formData.cpf.replace(/[^Z0-9]/g, ""),
        rg: this.formData.rg.replace(/[^Z0-9]/g, "").toUpperCase(),
        orgao_expedidor_id: this.formData.orgao_expedidor,
        data_emissao_rg: this.formatDateToSave(this.formData.data_emissao_rg),
        naturalidade: this.formData.naturalidade.toUpperCase(),
        nacionalidade: this.formData.nacionalidade.toUpperCase(),
        filiacao: this.formData.filiacao.toUpperCase(),
        sexo: this.formData.sexo,
        estado_civil: this.formData.estado_civil,
        data_nascimento: this.formatDateToSave(this.formData.data_nascimento),
        regime_casamento: this.formData.regime_casamento,
        profissao: this.formData.profissao.toUpperCase(),

        fone: this.formData.fone,
        celular: this.formData.celular.replace(/[^Z0-9]/g, ""),
        cadastro_tipo: this.formData.cadastro_tipo,
        nome_fantasia: this.formData.nome_fantasia.toUpperCase(),
        cnpj: this.formData.cnpj.replace(/[^Z0-9]/g, ""),
        razao_social: this.formData.razao_social.toUpperCase(),
        endereco_cep: this.formData.endereco_cep,
        endereco_num: this.formData.endereco_num,
        endereco_complemento: this.formData.endereco_complemento.toUpperCase(),
        endereco: this.formData.endereco.toUpperCase(),
        endereco_bairro: this.formData.endereco_bairro.toUpperCase(),
        estado_id: this.formData.endereco_estado_id,
        cidade_id: this.formData.endereco_cidade_id,
        requer_autorizacao_sucata: this.formData.requer_autorizacao_sucata,

        pj_endereco_cep: this.formData.pj_endereco_cep,
        pj_endereco_num: this.formData.pj_endereco_num.toUpperCase(),
        pj_endereco_complemento: this.formData.pj_endereco_complemento.toUpperCase(),
        pj_endereco_bairro: this.formData.pj_endereco_bairro.toUpperCase(),
        pj_endereco: this.formData.pj_endereco.toUpperCase(),
        pj_endereco_estado_id: this.formData.pj_endereco_estado_id,
        pj_endereco_cidade_id: this.formData.pj_endereco_cidade_id,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/user/profile/complete`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Cadastro enviado!");

            window.location.href = "/user";
          } else {
            this.showErrorMessageWithButton("Ops..", response.data.msg);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card-outline:hover {
  background-color: #428bca;
  cursor: pointer;
}

.inner {
  background-color: white;
}

label,
h3,
input {
  color: black;
}
</style>
